/**
 * In-memory, per-page-load signal that `ReduxInitializer` has just processed a
 * `?action=logout` landing.
 *
 * Deliberately NOT sessionStorage or a cookie. The marker does not reliably leave the
 * URL (the App Router re-syncs the address bar and undoes both `history.replaceState`
 * and `router.replace`), so a persisted flag - or re-reading the query string later -
 * would let a plain reload replay the reset against a session the user has since logged
 * back into. Module state dies with the page, so this fires on exactly the load that
 * handled the logout and never again.
 */
let logoutProcessed = false;

export function markLogoutProcessed(): void {
  logoutProcessed = true;
}

/** Reads and clears the signal, so at most one consumer acts on it. */
export function consumeLogoutProcessed(): boolean {
  const value = logoutProcessed;
  logoutProcessed = false;
  return value;
}
